import { render, staticRenderFns } from "./tablePlan1.vue?vue&type=template&id=f8dd7842&scoped=true"
import script from "./tablePlan1.vue?vue&type=script&lang=js"
export * from "./tablePlan1.vue?vue&type=script&lang=js"
import style0 from "./tablePlan1.vue?vue&type=style&index=0&id=f8dd7842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dd7842",
  null
  
)

export default component.exports